import * as React from 'react';

import { Pagination } from '../../components/Pagination';
import { usePagination } from './usePagination';

export function PaginationContainer() {
  const { onPageSelect, pages, nextPage, prevPage } = usePagination();

  const handleClickPagination = React.useCallback(
    (e: React.SyntheticEvent<HTMLAnchorElement>, page: number) => {
      e.preventDefault();
      onPageSelect(page);

      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    [onPageSelect],
  );

  if (pages.length === 0) {
    return null;
  }

  return <Pagination nextButton={nextPage} prevButton={prevPage} pages={pages} onClick={handleClickPagination} />;
}
